import { defineEntity, lifecycle, custom } from './_helpers.js';

export default defineEntity('privacyNotice', {
    // lifecycle so the event-trigger bridge can start the approval workflow
    submitted: lifecycle(),
    published: custom({ scope: 'state' }),
    reviewRequired: custom({ scope: 'state' }),
});
